import OrderPickingIcon from "../../assets/icons/OrderPicking.svg";
import { useSelector, useDispatch } from "react-redux";
import { useEffect, useState } from "react";

import { TotalStockAvailable } from "../../redux/actions/action";

import "../../assets/styles/local/Stock.css";

const TotalStockAvailableCard = ({ displayQuantity, displayLabel = "" }) => {
  const packageId = window.localStorage.getItem("packageId")
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(TotalStockAvailable());
  }, []);

  const [stockData, setStockData] = useState([]);
  const fetchTotalStockData = useSelector(
    (state) => state.user.totalStockAvailable
  );

  useEffect(() => {
    if (fetchTotalStockData != null) {
      if (fetchTotalStockData?.status && fetchTotalStockData?.data) {
        let _stockData = displayQuantity
          ? fetchTotalStockData?.data.slice(0, displayQuantity)
          : fetchTotalStockData?.data;
        setStockData(_stockData);
      }
    }
  }, [fetchTotalStockData]);

  const formatNumber = (number) => {
    return number ? number.toFixed(0).replace(/\d(?=(\d{3})+$)/g, "$&,") : 0;
  };

  return (
    <>
      <div className={
          packageId === process.env.REACT_APP_IS_PLUS
            ? "E_Plus_class sub-stock"
            : "total-stock sub-stock minheight-42-vh"
        }
      >
        <div className="stock-title">
          <div className="d-flex justify-content-end totalStock-img">
            <img
              src={OrderPickingIcon}
              className="stock-card-products-img"
              alt="totalStock"
            />
          </div>
          <p className="stock-title-main">
            {displayLabel ? displayLabel : "Total Stock Available"}
          </p>
        </div>
        <div className="sub-items">
          {stockData.map((item) => (
            <div className="stock-title" key={item.partid}>
              <div className="d-flex justify-content-end sub-items-count">
                <p className="sub-items-count-title">
                  {formatNumber(item.instock)}
                </p>
              </div>
              <p className="description">{item.partname}</p>
            </div>
          ))}
        </div>
      </div>
    </>
  );
};

export default TotalStockAvailableCard;
